import { useAtom } from "jotai";
import { notification } from "antd";
import EvaluacionService from "services/EvaluacionService";
import {
	evaluacionPendienteSeleccionadaAtom,
	visibleModalEvaluacionMecanicoAtom
} from "../../BandejaEvaluacionStorage";
import usePreguntasPuntualidad from "./usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "./usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "./usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "./usePreguntasActitudTrabajoEquipo";
import usePreguntasPredisposicion from "./usePreguntasPredisposicion";
import usePreguntasImagenRepresentacionEmpresa from "./usePreguntasImagenRepresentacionEmpresa";
import useObservacionResultado from "./useObservacionResultado";
import useResultadoEvaluacionConductor from "./useResultadoEvaluacionConductor";
import usePlanAccion from "./usePlanAccion";
import useRenovacion from "./useRenovacion";
import useModalFirmarEvaluacion from "./useModalFirmarEvaluacion";
import usePreguntasConocimientosTecnicos from "./usePreguntasConocimientosTecnicos";
import usePreguntasCalidadTrabajo from "./usePreguntasCalidadTrabajo";
import usePreguntasProductividadEficiencia from "./usePreguntasProductividadEficiencia";
import usePreguntasResponsabilidadPuntualidad from "./usePreguntasResponsabilidadPuntualidad";
import usePreguntasTrabajoEnEquipoActitud from "./usePreguntasTrabajoEnEquipoActitud";
import usePreguntasResolucionProblemaTomaDecisiones from "./usePreguntasResolucionProblemaTomaDecisiones";
import useResultadoEvaluacionMecanico from "./useResultadoEvaluacionMecanico";

const useModalEvaluacionMecanico = () => {
	const [visibleModalEvaluacionMecanico, setVisibleModalEvaluacionMecanico] = useAtom(visibleModalEvaluacionMecanicoAtom);
	const { mostrarModal: mostrarModalFirmarEvaluacion } = useModalFirmarEvaluacion();
	const [evaluacionPendienteSeleccionada, setEvaluacionPendienteSeleccionada] = useAtom(
		evaluacionPendienteSeleccionadaAtom
	);
	
	const { frmPreguntas: frmPreguntasConocimientosTecnicos } = usePreguntasConocimientosTecnicos();
	const { frmPreguntas: frmPreguntasCalidadTrabajo } = usePreguntasCalidadTrabajo();
	const { frmPreguntas: frmPreguntasProductividadEficiencia } = usePreguntasProductividadEficiencia();
	const { frmPreguntas: frmPreguntasResponsabilidadPuntualidad} = usePreguntasResponsabilidadPuntualidad();
	const { frmPreguntas: frmPreguntasTrabajoEquipoActitud } = usePreguntasTrabajoEnEquipoActitud();
	const { frmPreguntas: frmPreguntasResolucionProblemaTomaDecisiones } = usePreguntasResolucionProblemaTomaDecisiones();
	const { frmObservacionResultados } = useObservacionResultado();
	const { frmPlanAccion } = usePlanAccion();
	const { frmRenovacion } = useRenovacion();
	const { puntajeTotalEvaluacionMecanico } = useResultadoEvaluacionMecanico();

	const onClickBtnEnviar = async () => {
		try {
			await frmPreguntasConocimientosTecnicos.validateFields();
			await frmPreguntasCalidadTrabajo.validateFields();
			await frmPreguntasProductividadEficiencia.validateFields();
			await frmPreguntasResponsabilidadPuntualidad.validateFields();
			await frmPreguntasTrabajoEquipoActitud.validateFields();
			await frmPreguntasResolucionProblemaTomaDecisiones.validateFields();
			await frmObservacionResultados.validateFields();
			await frmPlanAccion.validateFields();
			await frmRenovacion.validateFields();

			const resultado = {
				evaluacionId: evaluacionPendienteSeleccionada.id,
				preguntasConocimientosTecnicos: getPreguntas(frmPreguntasConocimientosTecnicos),
				preguntasCalidadTrabajo: getPreguntas(frmPreguntasCalidadTrabajo),
				preguntasProductividadEficiencia: getPreguntas(frmPreguntasProductividadEficiencia),
				preguntasResponsabilidadPuntualidad: getPreguntas(frmPreguntasResponsabilidadPuntualidad),
				preguntasTrabajoEquipoActitud: getPreguntas(frmPreguntasTrabajoEquipoActitud),
				preguntasResolucionProblemaTomaDecisiones: getPreguntas(frmPreguntasResolucionProblemaTomaDecisiones),
				puntajeTotal: puntajeTotalEvaluacionMecanico,
				observacion: frmObservacionResultados.getFieldValue("observacion"),
				resultado: getResultado(puntajeTotalEvaluacionMecanico),
				planesAccion: frmPlanAccion.getFieldValue("planAccion"),
				renovarContrato: frmRenovacion.getFieldValue("renovarContrato"),
				mesesRenovacion: frmRenovacion.getFieldValue("mesesRenovacion"),
				tipoEvaluacion:"MECANICO"
			};

			setEvaluacionPendienteSeleccionada({ ...evaluacionPendienteSeleccionada, resultado: resultado });
			mostrarModalFirmarEvaluacion();

			console.log("onClickBtnEnviar");
		} catch (error) {
			console.log("errores", error);
		}
	};

	const getPreguntas = (frmPreguntas) => {
		const entradas = Object.entries(frmPreguntas.getFieldsValue());
		let data = entradas.map(([pregunta, puntuacion]) => {
			return {
				pregunta: pregunta,
				puntuacion: puntuacion,
			};
		});
		return data;
	};

	const getResultado = (puntajeTotal) => {
		if (puntajeTotal >= 0 && puntajeTotal <= 50) {
			return "No Apto";
		} else if (puntajeTotal >= 51 && puntajeTotal <= 75) {
			return "Apto con Observaciones (Plan de acción)";
		} else if (puntajeTotal >= 76 && puntajeTotal <= 85) {
			return "Bueno (Plan de Acción opcional)";
		} else if (puntajeTotal >= 86 && puntajeTotal <= 95) {
			return "Destacado";
		} else if (puntajeTotal >= 96 && puntajeTotal <= 100) {
			return "Excelente";
		}
	};

	const mostrarModalMecanico = (evaluacion) => {
		setEvaluacionPendienteSeleccionada(evaluacion);
		setVisibleModalEvaluacionMecanico(true);
		console.log("evaluacion", evaluacion);
	};

	const ocultarModal = () => {
		setVisibleModalEvaluacionMecanico(false);
	};

	return {
		mostrarModalMecanico,
		ocultarModal,
		visibleModalEvaluacionMecanico,
		onClickBtnEnviar,
	};
};

export default useModalEvaluacionMecanico;
